import React, { Fragment } from 'react';
import $ from 'jquery';
import Tippy from '@tippyjs/react';

import SlackGrantAccessButton from '../SlackGrantAccessButton';
import SlackConversationSelector from '../SlackConversationSelector';
import { hasSlackFeature } from '../../utilities/featureHelper';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import { getUpgradePlanUrl } from '../../utilities/urlHelper';

class SlackMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getState(props);
    }

    getState = (props) => {
        const slackShareAbility = this.getSlackShareAbility();
        const loading = !slackShareAbility;

        return {
            enableButton: null,
            loading,
            slackShareAbility,
            selectedConversation: null,
            slackMessage: '',
            errorMessage: '',
            slackScopeUrl: null,
        };
    };

    getSlackShareAbility = () => {
        if (window.slackShareAbility) {
            return window.slackShareAbility;
        }

        $.get(`/api/teams/${window.teamId}/users/${window.userId}/integrations/has-slack-share-scope`)
            .then(({ success, slackScopeUrl }) => {
                const loading = false;
                if (success) {
                    window.slackShareAbility = true;
                    const enableButton = true;
                    return this.setState({ loading, enableButton });
                }
                const enableButton = false;
                return this.setState({ slackScopeUrl, loading, enableButton });
            }).catch(console.error);

        return null;
    };

    clickGrantAccess = () => {
        const { slackScopeUrl } = this.state;
        const urlSeparator = window.location.href.includes('?') ? '&' : '?';
        const returnUrl = encodeURIComponent(`${window.location.href}${urlSeparator}showSlackShareModal=${this.props.page.id}`);
        window.location = `${slackScopeUrl}?returnUrl=${returnUrl}`;
    };

    onConversationChange = (selectedConversation) => {
        const enableButton = !!selectedConversation;
        this.setState({ selectedConversation, enableButton });
    };

    onMessageChange = (event) => this.setState({ slackMessage: event.target.value });

    onClickSharePage = () => {
        const { selectedConversation, slackMessage: message } = this.state;
        const { id } = selectedConversation.value;
        const URL = `/api/teams/${teamId}/pages/${this.props.page.id}/slack-shares`;
        const _token = window.csrfToken;

        this.setState({ enableButton: false });
        $.post(URL, { message, id, _token })
            .then(response => {
                if (response.success) {
                    const { page } = this.props;
                    addSuccessMessage(`You just shared "${page.title}" to ${selectedConversation.label} via Slack!`);
                    this.close();
                } else {
                    throw 'Failed slack share';
                    const { setErrorMessage } = this.props;
                    setErrorMessage('Slack share failed. Please try again, and contact us if problems continue.');
                    this.setState({ enableButton: true });
                }
            })
            .catch(error => {
                console.error(error);
                const { setErrorMessage } = this.props;
                setErrorMessage('Slack share failed. Please try again, and contact us if problems continue.');
                this.setState({ enableButton: true });
            });
    };

    close = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {
        const {
            enableButton, statusText, loading, selectedConversation, slackScopeUrl,
        } = this.state;
        const btnDisabledClass = enableButton && selectedConversation ? '' : 'is-disabled';

        return (
            <div className="mt2">
                {loading
                    ? (<div className="loading gray">Checking slack permissions</div>)
                    : !slackScopeUrl
                        ? hasSlackFeature() ? (
                            <div className="mt2">
                                <label className="bold block col-12 mb1">Share with</label>
                                <SlackConversationSelector onConversationChange={this.onConversationChange} />
                                <label className="bold block col-12 mb1">Your message</label>
                                <textarea className="field col-12" placeholder="optional" onChange={this.onMessageChange} />
                            </div>
                        ) : (
                            <Fragment>
                                <p className="mb0 italic">This feature requires a Scaling account</p>
                                <Tippy content="to enable Slack integration" placement="bottom">
                                    <a
                                        className="btn-tertiary ml1 mt1 btn-teal upgrade-button"
                                        href={getUpgradePlanUrl()}
                                    >
                                        upgrade
                                    </a>
                                </Tippy>
                            </Fragment>
                        ) : (
                            <SlackGrantAccessButton onMouseDown={this.clickGrantAccess} />
                        )}

                <div className="mt3 right-align">
                    <span className="left green">{statusText}</span>
                    <span className="react-modal-close btn-secondary mr1" onMouseDown={this.close}>Close</span>
                    <span onMouseDown={this.onClickSharePage} className={`btn btn-primary ${btnDisabledClass}`}>Share page</span>
                </div>
            </div>
        );
    }
}

export default SlackMenu;
